import BigNumber from 'bignumber.js';
import CryptoJS from "crypto-js";
import * as util from 'ethereumjs-util';
import API from '../conf/API';
import { Events, JSEvent } from '../utils/JSEvent';
import { post, request } from '../utils/request';
import DataCenter, { Calculator, QuoteCoinID, TransactionMethod } from './DataCenter';
import { Localize } from './localize/Localize';
import { ETHWalletProvider } from './wallet/ETHWalletProvider';
import { MATICWalletProvider } from './wallet/MATICWalletProvider';
import { SOLWalletProvider } from './wallet/SOLWalletProvider';
import { base64 } from 'ethers/lib/utils';

const walletSaveKey = () => {
    return "WalletData_" + DataCenter.profile.id;
}

const walletEncryptKey = () => {
    return "Wallet_" + DataCenter.profile.id + "$_$" + DataCenter.profile.username;
}

/**
 * 钱包被create、import、load成功后，都会调用
 * @param {钱包信息} walletInfo 
 */
const onWalletCreated = (walletInfo) => {

    // const { data, blockchain } = WalletService;

    // let web3 = null;
    // let provider = null;

    // switch (blockchain.key) {
    //     case "eth":
    //         web3 = new Web3(new Web3.providers.WebsocketProvider(blockchain.url));
    //         provider = new ETHWalletProvider(web3)
    //         break;
    // }

    if (WalletService.provider != null) {
        WalletService.provider.onWalletLoaded(walletInfo).then(p => {
            DataCenter.getCoins().forEach(coin => {
                walletInfo.balance(coin);
            })
        })
    }
    JSEvent.emit(Events.Wallet.Created, walletInfo);



    //TODO 更新钱包信息给服务器


    // request(API.defi_token_list()).then(ret => {
    //     if (!ret.error) {
    //         WalletService.data.tokens = ret.retObject.tokens;
    //         WalletService.data.coinPoolAddress = ret.retObject.coinPoolAddress;

    //         WalletService.subscribe();

    //         JSEvent.emit(Events.Wallet.DataUpdate, {
    //             name: "tokens", value: WalletService.data.tokens
    //         });
    //         JSEvent.emit(Events.Wallet.DataUpdate, {
    //             name: "coinPoolAddress", value: WalletService.data.coinPoolAddress
    //         });

    //         WalletService.data.tokens.forEach(token => {
    //             walletInfo.balance(token);
    //         })
    //     }
    // })

}

export const TransactionState = {
    TRANSACTION_STATE_ERROR: -1,
    TRANSACTION_STATE_CREATED: 0,
    TRANSACTION_STATE_PROCESSING: 1,
    TRANSACTION_STATE_CONFIRMING: 2,
    TRANSACTION_STATE_CONFIRMED: 3,
    TRANSACTION_STATE_SENDING: 4,
    TRANSACTION_STATE_SENT: 5,
}

export const WalletService = {
    ready: false,
    web3: null,
    walletInfo: null,
    /**
     * {WalletProvider} provider
     */
    provider: null,
    subscribes: [],

    data: {
        coinPoolAddress: "",
        //tokens: []
    },
    init: () => {
        WalletService.ready = true;
        //init provider
        switch (WalletService.blockchain.key) {
            case "eth":
                WalletService.provider = new ETHWalletProvider(WalletService.blockchain)
                break;
            case "sol":
                WalletService.provider = new SOLWalletProvider(WalletService.blockchain);
                break;
            case "polygon":
            case "polygon-test":
                WalletService.provider = new MATICWalletProvider(WalletService.blockchain);
                break;
        }
        //load wallet
        WalletService.loadWallet().then(r => {
            JSEvent.emit(Events.Wallet.Ready, {})

            JSEvent.on(Events.Wallet.PenddingTransaction, WalletService.onPendingTransaction);
            JSEvent.on(Events.Wallet.Transaction, WalletService.onTransaction);

            WalletService.provider.subscribe();
        });

    },

    onPendingTransaction: ({ token, walletTxInfo }) => {
        const walletTxUpdate = {
            orderId: walletTxInfo.orderId,
            transferNet: walletTxInfo.transferNet,
            transactionHash: walletTxInfo.transactionHash,
            state: TransactionState.TRANSACTION_STATE_PROCESSING,
        }

        if (walletTxInfo.txMethod == TransactionMethod.Topup) {
            //Topup订单需要更新transaction状态给服务器，提交transactionHash
            post(API.wallet_trans_update(), walletTxUpdate).then(ret => {
                //这里不做更新了，统一挪到TransactionService中的接口
                //walletTxInfo.state = TransactionState.TRANSACTION_STATE_CONFIRMING;
            });
        }

    },

    onTransaction: ({ token, trans, walletTxInfo }) => {
        console.log("WalletService.onTransaction: ", walletTxInfo)
        const walletTxUpdate = {
            orderId: walletTxInfo.orderId,
            transferNet: walletTxInfo.transferNet,
            transactionHash: walletTxInfo.transactionHash,
            state: TransactionState.TRANSACTION_STATE_CONFIRMED,
        }

        if (walletTxInfo.txMethod == TransactionMethod.Transfer) {
            walletTxUpdate.state = walletTxInfo.state;
        }
        //更新transaction状态
        post(API.wallet_trans_update(), walletTxUpdate).then(ret => {
            if (ret.error) {
                //更新出错了
            } else {
                //到帐了
                // const txInfo = WalletService.pendingTrans[walletTxInfo.transactionHash];
                // if (txInfo) {
                //     txInfo.state = TransactionState.TRANSACTION_STATE_CONFIRMED;
                // }
            }
        })
        // }
    },
    subscribe: () => {
        if (WalletService.provider != null) {
            WalletService.provider.subscribe();
        }
    },

    createWallet: () => {
        return new Promise(resolve => {
            if (WalletService.walletInfo == null) {
                _createWallet().then(wi => {
                    WalletService.walletInfo = wi;
                    //JSEvent.emit(Events.Wallet.Created, WalletService.walletInfo);
                    onWalletCreated(WalletService.walletInfo);
                    WalletService.saveWallet();
                    resolve(wi);
                });
            } else {
                resolve(WalletService.walletInfo);
                //JSEvent.emit(Events.Wallet.Created, WalletService.walletInfo);
                onWalletCreated(WalletService.walletInfo);
            }
        })
    },

    importWalletByPk: (pk) => {
        const wi = WalletService.provider.importPrivateKey(pk);
        WalletService.walletInfo = wi;
        onWalletCreated(WalletService.walletInfo);
        WalletService.saveWallet();
        return wi;
    },

    importWallet: (mnemonic) => {
        return new Promise((resolve, reject) => {
            _importWallet(mnemonic).then(wi => {
                WalletService.walletInfo = wi;
                //JSEvent.emit(Events.Wallet.Created, WalletService.walletInfo);
                onWalletCreated(WalletService.walletInfo);
                WalletService.saveWallet();
                resolve(wi);
            }, err => {
                reject(err);
            })
        });
    },

    resetWallet: () => {
        if (WalletService.walletInfo != null) {
            localStorage.removeItem(walletSaveKey());
            WalletService.walletInfo = null;
            JSEvent.emit(Events.Wallet.Reset);
        }
    },

    saveWallet: () => {
        if (WalletService.walletInfo != null) {
            const data = JSON.stringify(WalletService.walletInfo);
            const key = CryptoJS.MD5(walletEncryptKey()).toString();
            const iv = CryptoJS.MD5(walletEncryptKey()).toString();

            const encrypted = CryptoJS.AES.encrypt(data, key, {
                iv: iv,
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            })

            localStorage.setItem(walletSaveKey(), encrypted.toString());
        }
    },

    encryptData: (data) => {
        const str = JSON.stringify(data);

        const key = walletEncryptKey();
        const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
        const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

        const key1 = CryptoJS.PBKDF2(key, CryptoJS.enc.Hex.parse(salt), { keySize: 128 / 32, iterations: 1000 })

        const encrypted = CryptoJS.AES.encrypt(str, key1, {
            iv: iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        })
        const text = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
        return text;
    },

    loadWallet: () => {
        return new Promise(async (resolve, reject) => {
            if (WalletService.walletInfo == null && DataCenter.isLogin()) {
                try {
                    //强制从服务器读取钱包
                    var ret = await post(API.account_get_wallet());

                    if (!ret.error) {
                        const v1 = Buffer.from(ret.retObject, 'base64').toString();
                        const v = v1.split(",");
                        if (v.length > 1) {
                            try {
                                //不足64长度前面补0
                                while (v[0].length < 64) {
                                    v[0] = '0' + v[0];
                                }

                                WalletService.importWalletByPk(v[0]);
                                //WalletService.provider.importPrivateKey(v[0]);
                                //await WalletService.importWallet(v[1]);
                                resolve(true);
                            } catch (e) {
                                console.error(e);
                            }
                        }
                    }


                    // post(API.account_get_wallet()).then(ret => {
                    //     if (ret.error) {
                    //         console.log(ret)
                    //         resolve(false);
                    //     } else {
                    //         const v1 = Buffer.from(ret.retObject, 'base64').toString();
                    //         if (v1.indexOf(",") != -1) {
                    //             const v = v1.split(",");

                    //         }
                    //     }
                    // })

                    const encryptedData = localStorage.getItem(walletSaveKey());
                    if (encryptedData == null) {
                        return resolve(false);
                    }

                    const key = CryptoJS.MD5(walletEncryptKey()).toString();
                    const iv = CryptoJS.MD5(walletEncryptKey()).toString();

                    const decrypt = CryptoJS.AES.decrypt(encryptedData, key, {
                        iv: iv,
                        mode: CryptoJS.mode.ECB,
                        padding: CryptoJS.pad.Pkcs7
                    })

                    const data = decrypt.toString(CryptoJS.enc.Utf8);

                    const walletInfo = JSON.parse(data);
                    WalletService.walletInfo = new WalletInfo();
                    for (const key in walletInfo) {
                        WalletService.walletInfo[key] = walletInfo[key];
                    }

                    //JSEvent.emit(Events.Wallet.Created, WalletService.walletInfo);
                    onWalletCreated(WalletService.walletInfo);

                    resolve(true);
                } catch (e) {
                    console.log(e);
                    reject(e);
                }
            }
        })
    },

    address: () => {
        const wi = WalletService.walletInfo;
        if (wi == null) {
            return null;
        }
        return wi.address;
    },

    isDeFiWalletAddr(address) {
        const wi = WalletService.walletInfo;
        if (wi == null) {
            return false;
        }

        const defi = WalletService.address();
        if (!util.isValidAddress(address)) {
            return false;
        }
        //const addr = util.Address.fromString(address);

        if (defi.equals) {
            return defi.equals(address);
        } else {
            return defi == address;
        }
    },

    eclipsisAddress(address, len) {
        const addr = util.stripHexPrefix(address);
        const s = addr.slice(0, len);
        const e = addr.slice(-len);
        return s + "..." + e;
    }
}

Object.defineProperties(WalletService, {
    blockchain: {
        get: () => DataCenter.blockchain()
    }
})

export class Token {
    #id;
    #name;
    #fullName;
    #address;
    constructor(id, name, fullName, address) {
        this.#id = id;
        this.#name = name;
        this.#fullName = fullName;
        this.#address = address;
    }

    get id() {
        return this.#id;
    }

    get name() {
        return this.#name
    }

    get fullName() {
        return this.#fullName
    }

    get address() {
        return this.#address
    }
}

export class WalletInfo {
    mnemonic = "";
    blockchain = "";
    privateKey = "";
    publicKey = "";
    address = "";
    //#provider = null;
    #tokenBalance = {};

    constructor() {
        this.onTransaction = this.onTransaction.bind(this);
        this.onWalletAccountChanged = this.onWalletAccountChanged.bind(this);
        JSEvent.on(Events.Wallet.Transaction, this.onTransaction);
        JSEvent.on(Events.Wallet.WalletAccountChanged, this.onWalletAccountChanged)
    }

    onTransaction({ token, trans }) {
        this.#updateBalance(token)
    }

    onWalletAccountChanged(token) {
        this.#updateBalance(token)
    }

    // get provider() {
    //     return this.#provider;
    // }

    // set provider(provider) {
    //     this.#provider = provider;
    //     this.#tokenBalance = {}
    // }

    ellipsisAddress(len) {
        return WalletService.eclipsisAddress(this.address, len);
    }

    /**
     * 返回钱包中所有token的总和，已指定的计价货币为单位
     * @param {计价货币Id} quoteCoinId 
     * @returns {BigNumber} 
     */
    totalBalance(quoteCoinId = QuoteCoinID) {
        let total = new BigNumber(0);

        for (const tokenId in this.#tokenBalance) {
            const b = this.#tokenBalance[tokenId];
            const qb = DataCenter.getCoinPriceInQuote(tokenId, b, quoteCoinId);
            total = total.plus(qb);
        }

        return total;
    }

    async asyncbalance(token) {
        return await (this.balance(token));
    }

    /**
     * @param {Token} token 
     * @returns 
     */
    balance(token) {
        return new Promise((resolve, reject) => {
            if (WalletService.provider == null || token == null) {
                resolve("--")
            } else {

                if (this.#tokenBalance[token.id] != null) {
                    if (resolve)
                        resolve(this.#tokenBalance[token.id]);
                    return;
                }
                this.#updateBalance(token, resolve, reject);
            }
        })
    }


    #updateBalance(token, resolve, reject) {
        WalletService.provider.balanceOf(token, this.address).then(
            v => {
                this.#tokenBalance[token.id] = v;
                JSEvent.emit(Events.Wallet.BalanceUpdate, { token: token, balance: v });
                if (resolve)
                    resolve(v);
            }, err => {
                if (reject)
                    reject(err);
            }
        );
    }
}

const _createWallet = () => {
    return new Promise((resolve, reject) => {
        if (WalletService.provider == null) {
            reject("provider is null");
            return;
        }
        const mnemonic = WalletService.provider.makeNewMnemonic();
        _importWallet(mnemonic).then(wi => {
            resolve(wi);
        })
    })
}

const _importWallet = (mnemonic) => {
    return new Promise((resolve, reject) => {
        if (WalletService.provider == null) {
            reject({ code: -1, msg: "provider is null" })
            return;
        }

        WalletService.provider.importMnemonic(mnemonic).then(wi => {
            resolve(wi);
        }, err => {
            reject(err);
        });

    })
}


export class WalletTxInfo {
    coinType;
    walletAccount;
    txMethod;
    transferNet;
    amount;
    txFrom;
    txTo;
    nonce;
    transactionHash;
    orderId;
    signature;
    transDate;
    #gasPrice;
    #gasUsed;

    get gasPrice() {
        return this.#gasPrice;
    }

    set gasPrice(v) {
        if (v != null && v._isBigNumber) {
            this.#gasPrice = v;
        } else {
            this.#gasPrice = new BigNumber(v);
        }
    }

    get gasUsed() {
        return this.#gasUsed;
    }

    set gasUsed(v) {
        if (v != null && v._isBigNumber) {
            this.#gasUsed = v;
        } else {
            this.#gasUsed = new BigNumber(v);
        }
    }

    constructor(retObject) {
        this.coinType = 0;
        this.walletAccount = 0;
        this.txMethod = 0;
        this.transferNet = "";
        this.amount = 0;
        this.txFrom = "";
        this.txTo = "";
        this.gasPrice = "";
        this.nonce = "";
        this.gasUsed = "";
        this.transactionHash = "";
        this.orderId = 0;
        this.signature = "";
        this.transDate = "";

        if (retObject != null) {
            this.fromRetObject(retObject);
        }
    }

    requestBody() {
        return {
            coinType: this.coinType,
            walletAccount: this.walletAccount,
            txMethod: this.txMethod,
            transferNet: this.transferNet,
            amount: this.amount,
            txFrom: this.txFrom,
            txTo: this.txTo,
            nonce: this.nonce,
            transactionHash: this.transactionHash,
            orderId: this.orderId,
            signature: this.signature,
            gasPrice: this.gasPrice,
            gasUsed: this.gasUsed,
        }
    }

    fromRetObject(retObject) {
        for (const key in retObject) {
            this[key] = retObject[key];
        }
    }
    getGasFee() {
        const quoteCoin = DataCenter.getCoin(QuoteCoinID);
        return WalletService.provider.calcGasFee(this.gasPrice, this.gasUsed, quoteCoin).str;
    }
    getAmount(excludeGasFee = true) {
        const coin = DataCenter.getCoin(this.coinType);
        const g = new BigNumber(this.getGasFee());
        const a = Calculator.toNumber(this.amount, coin.id)
        const v = excludeGasFee && this.coinType == QuoteCoinID ? a.minus(g) : a;
        const zero = new BigNumber(0);
        if (v.isLessThan(zero)) {
            //小于零
            return zero;
        }
        return v;
    }
    getTxFrom() {
        if (WalletService.isDeFiWalletAddr(this.txFrom)) {
            return Localize.getMsg(Localize.UI.WalletView.defiWallet);
        }
        return this.txFrom;
    }
    getTxTo() {
        if (WalletService.isDeFiWalletAddr(this.txTo)) {
            return Localize.getMsg(Localize.UI.WalletView.defiWallet);
        }
        return this.txTo;
    }
}
WalletTxInfo.prototype.__class_name = "WalletTxInfo";

new WalletTxInfo();

JSEvent.on(Events.DataCenter.DATA_UPDATED, name => {
    if (name == "symbol") {
        WalletService.init();
    }
});
